<template>
  <q-layout view="lHh Lpr lFf">
    <!-- Header - Esconder na rota de login -->
    <q-header v-if="!isLoginRoute" elevated class="glossy bg-primary">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        <q-icon>
          <q-avatar size="56px" style=" margin-left: 10px;">
            <img src="./assets/icon2.png" />
          </q-avatar>
        </q-icon>
      </q-toolbar>
    </q-header>

    <!-- Drawer - Esconder na rota de login -->
    <q-drawer
      v-if="!isLoginRoute"
      v-model="leftDrawerOpen"
      show-if-above
      bordered
      class="bg-primary"
      :width="250"
    >
      <!-- Header do Drawer com Profile -->
      <div class="q-pa-md bg-gradient-secondary text-white">
        <div class="row items-center q-mb-sm">
          <q-avatar size="50px" class="q-mr-md">
            <img src="https://amzn-s3-goldenkey.s3.us-east-2.amazonaws.com/properties/icon2.png" />
          </q-avatar>
          <div class="col">
            <div class="text-weight-bold">{{ fullname }}</div>
            <div class="text-caption">{{ role === 0 ?  "Agente Imobiliario" : (role === 1 ? "Admin" : "Permissão invalida") }}</div>
          </div>
        </div>
      </div>

      <!-- Menu de Navegação -->
      <q-list class="q-pt-md">
        <!-- Dashboard -->
        <!-- <q-item 
          clickable 
          v-ripple 
          :active="selectedMenu === 'dashboard'"
          active-class="bg-primary text-white"
          class="q-mb-xs q-mx-sm rounded-borders"
          to="/dashboard"
        >
          <q-item-section avatar>
            <q-icon name="dashboard" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Dashboard</q-item-label>
          </q-item-section>
        </q-item> -->

        <!-- Imóveis -->
        <q-item 
          clickable 
          v-ripple
          :active="selectedMenu === 'imoveis'"
          active-class="bg-primary text-white"
          class="q-mb-xs q-mx-sm rounded-borders"
          to="/imoveis"
        >
          <q-item-section avatar>
            <q-icon name="home" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Meus Imóveis</q-item-label>
          </q-item-section>
        </q-item>

        <!-- Contratos -->
        <!-- <q-item 

          clickable 
          v-ripple
          :active="selectedMenu === 'contratos'"
          active-class="bg-primary text-white"
          class="q-mb-xs q-mx-sm rounded-borders"
          to="/contratos"
        >
          <q-item-section avatar>
            <q-icon name="assignment" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Contratos</q-item-label>
          </q-item-section>
        </q-item> -->

        <!-- Agentes -->
        <q-item 
          v-if="role === 1"
          clickable 
          v-ripple
          :active="selectedMenu === 'todos-imoveis'"
          active-class="bg-primary text-white"
          class="q-mb-xs q-mx-sm rounded-borders"
          to="/todos-imoveis"
          
        >
          <q-item-section avatar>
            <q-icon name="people" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Todos Imoveis</q-item-label>
          </q-item-section>
        </q-item>
        <q-item 
          v-if="role === 1"
          clickable 
          v-ripple
          :active="selectedMenu === 'utilizadores'"
          active-class="bg-primary text-white"
          class="q-mb-xs q-mx-sm rounded-borders"
          :to="{ name: 'user-list' }"
        >
          <q-item-section avatar>
            <q-icon name="people" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Utilizadores</q-item-label>
          </q-item-section>
        </q-item>

        <!-- Separator -->
        <q-separator class="q-my-md" />

        <!-- Relatórios -->
        <q-item 
          v-if="role === 1"
          clickable 
          v-ripple
          :active="selectedMenu === 'relatorios'"
          active-class="bg-primary text-white"
          class="q-mb-xs q-mx-sm rounded-borders"
        >
          <q-item-section avatar>
            <q-icon name="analytics" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Relatórios</q-item-label>
          </q-item-section>
        </q-item>

        <!-- Separator -->
        <q-separator class="q-my-md" />

        <!-- Configurações -->
        <q-item 
          clickable 
          v-ripple
          :active="selectedMenu === 'config'"
          active-class="bg-primary text-white"
          class="q-mb-xs q-mx-sm rounded-borders"
          to="/profile"
        >
          <q-item-section avatar>
            <q-icon name="settings" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Configurações</q-item-label>
          </q-item-section>
        </q-item>

        <!-- Ajuda -->
        <!-- <q-item 
          clickable 
          v-ripple
          :active="selectedMenu === 'ajuda'"
          active-class="bg-primary text-white"
          class="q-mb-xs q-mx-sm rounded-borders"
          to="/ajuda"
        >
          <q-item-section avatar>
            <q-icon name="help" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Ajuda</q-item-label>
          </q-item-section>
        </q-item> -->
      </q-list>

      <!-- Footer -->
      <div class="absolute-bottom q-pa-md">
        <q-btn 
          flat 
          dense 
          icon="logout" 
          label="Sair" 
          class="full-width text-negative"
          @click="handleLogout"
        />
      </div>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import store from './vuex/store';

export default {
  name: 'LayoutDefault',

  setup () {
    const route = useRoute()
    const router = useRouter()
    const leftDrawerOpen = ref(true)
    const selectedMenu = ref('')

    // Verifica se está na rota de login
    const isLoginRoute = computed(() => {
      return route.path === '/' || route.path === '/login' || route.path === '/auto-register' || route.path.startsWith('/activate-user') || route.path === '/reset-password' || route.path.startsWith('/reset/')
    })
    onMounted(() => {
      if(sessionStorage.getItem('token')) {
        store.dispatch('auth/getMe').then(() => {
          // console.log("User data fetched successfully.");
        }).catch(() => {
          router.push('/')
        });
      }
    })

    const handleLogout = async () => {
      // Limpar token e redirecionar para login
      try {
        await store.dispatch('auth/logout')
        sessionStorage.removeItem('token')
        router.push('/')
      } catch (error) {
        // console.error('Erro ao fazer logout:', error)
        sessionStorage.removeItem('token')  
        router.push('/')
      }
    }
    const fullname = computed(() => {
      console.log(store.state.auth.user?.name)
      return store.state.auth.user?.name || 'Usuário' ;
    })
    const role = computed(() => {
      console.log(store.state.auth.user?.role)
      return store.state.auth.user?.role;
    })
    return {
      leftDrawerOpen,
      selectedMenu,
      isLoginRoute,
      fullname,
      role,
      handleLogout
    }
  }
}
</script>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(135deg, #1976d2 0%, #2196f3 100%);
}
</style>